<template>
    <div>
    <p>This is a disk image with a signed and notarized GanttProject application. Java Runtime is bundled. You don't need to download anything else.</p>
    <div class="p-3">
        <strong>GanttProject {{ version }} for macOS Silicon</strong>
        <div class="help-text pb-3">Built on {{ releaseDate }}</div>
        <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/mac/silicon`" v-on:click="onDownloadStarted" data-track-event="dwnl,dwnl-gp34-silicon">Download for Apple Silicon [{{ sizeSilicon }}]</a>
    </div>

      <div class="p-3">
        <strong>GanttProject {{ version }} for macOS Intel</strong>
        <div class="help-text pb-3">Built on {{ releaseDate }}</div>
        <a role="button" class="btn btn-attention btn-lg" :href="`/dl/${version}/mac/intel`" v-on:click="onDownloadStarted" data-track-event="dwnl,dwnl-gp34-intel">Download for Intel [{{ sizeIntel }}]</a>
      </div>

      <h3>Maintenance updates</h3>
      <p>Maintenance updates to version {{ version }} will be delivered via our Update Channel.
        Please leave Auto-Update option in the settings switched on to let GanttProject to check for updates from time to time.
        When a new update becomes available, you will be able to review it and choose to install or skip.</p>

    </div>
</template>

<script>
import {gaSendEvent} from "@/components/Analytics";

    export default {
        name: "DownloadMac34",
        props: {
            releaseDate: String,
            sizeSilicon: String,
            sizeIntel: String,
            version: String,
            virustotalHash: String
        },
      methods: {
        onDownloadStarted: function() {
          gaSendEvent('download_started');
        }
      }
    }
</script>

<style scoped>

</style>
